export const setStorage = function( prefix , key , obj ) {
  localStorage.setItem( prefix + '-' + key , JSON.stringify( obj ) );
  console.info( 'Storage : _setStorage => (get:after) ' , getStorage( prefix , key ) );
}

export const getStorage = function( prefix , key ) {
  return JSON.parse( localStorage.getItem( prefix + '-' + key ) );
}

export const setCookie = function( name , state , days ) {
  if( days != 0 ){
    var expiresDate, date = new Date();
    date.setTime( date.getTime() + (days * 24 * 60 * 60 * 1000));
    expiresDate = date.toGMTString();
    window.document.cookie = name +'='+ state +'; expires=' + expiresDate + '; domain=.' + window.location.hostname + '; path=/';
  } else {
    window.document.cookie = name +'='+ state +'; domain=.' + window.location.hostname + '; path=/';
  }
}

export const getCookie = function( name ) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

export const delCookie = function( name ) {
  setCookie(name,'',-1);
}

export const toMMSS = (secs, { forceHours = false } = {}) => {
  const s = Math.max(0, Math.floor(Number(secs) || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const r = s % 60;
  if (forceHours || h > 0) {
    return `${h}:${String(m).padStart(2, '0')}:${String(r).padStart(2, '0')}`;
  }
  return `${String(m).padStart(2, '0')}:${String(r).padStart(2, '0')}`;
};

export const deepMerge = ( a , b ) => {
  const out = { ...a };
  if( b && typeof b === 'object' ){
    Object.keys( b ).forEach( key => {
      const bv = b[ key ];
      const av = out[ key ];
      if( Array.isArray( bv ) ){
        out[ key ] = bv.slice();
      } else if( bv && typeof bv === 'object' ){
        out[ key ] = deepMerge( av && typeof av === 'object' ? av : { } , bv );
      } else {
        out[ key ] = bv;
      }
    } );
  }
  return out;
};

export const addQuery = ( url , key , val ) => {
  try {
    const u = new URL( url , window.location.origin );
    u.searchParams.set( key , String( val ) );
    return u.toString();
  } catch( _ ){
    // relativo
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}${encodeURIComponent( key )}=${encodeURIComponent( String( val ) )}`;
  }
}

export const forceDownload  = ( url , filename ) => {
  if( typeof url !== 'string' || url.trim( ) === '' ) return;
  fetch( url )
    .then( r => {
      if( !r.ok ) throw new Error( 'Error en la descarga: ' + r.statusText );
      return r.blob( );
    } )
    .then( blob => {
      const enlace    = document.createElement( 'a' );
      const blobUrl   = URL.createObjectURL( blob );
      enlace.href     = blobUrl;
      enlace.download = filename;
      enlace.style.display = 'none';
      document.body.appendChild( enlace );
      enlace.click( );
      document.body.removeChild( enlace );
      URL.revokeObjectURL( blobUrl );
    } )
    .catch( err => console.error( '%forceDownload => error => ', 'color:red;' , err ) );
}
